import React, { useEffect, useState } from 'react'
import SlideUpWrapper from '../../../../components/Transitions/SlideUpWrapper'
import IssuerNavigator from '../../../../components/DashBoard/IssuerNavigator'
import styles from "../../CompanyProfile.module.css";
import templateStyles from "../../Templates/Templates.module.css";
import creditStyles from "./CreditHandler.module.css";
import { useLocation, useParams } from 'react-router-dom';
import Loader from '../../../../components/Loader';



import API from "../../../../ApiConfig";
import { BASE_URL, GET_WALLET_DETAILS, ISSUER_ADJUST_CREDITS, UPDATE_ISSUER_PER_SEARCH_CREDIT, UPDATE_ISSUER_WALLET, USER_TOKEN } from '../../../../Utils/constant';
import cogoToast from 'cogo-toast-react-17-fix';
import CustomDropDown from '../../../../components/CustomDropDown';
import StaggerredCredit from './StaggerredCredit';
import useRefreshToken from '../../../../Hooks/usegenerateToken';
const CreditHandler = () => {
    useRefreshToken(BASE_URL + USER_TOKEN)
    const location=useLocation()
    const [is_active, setIsActive]=useState(false)
    const [currentCredits, setCurrentCredits]=useState("")

    const [userDetails, setUserDetails]=useState("")

    const [perSearchCredit, setPerSearchCredit]=useState("")
    const [loading, setLoading]=useState(false)
    const {companyId}=useParams()
    const [amount, setAmount]=useState("")
    const [description, setDescription]=useState("")
    const [selectedCreditType, setSelectedCreditType]=useState("")
    const [slabs, setSlabs]=useState([{ from_search: '', to_search: '', credit_per_search: '' }])
    const CreditStatus=["flat", "staggered"]
    const handleCredit=()=>{
        setIsActive(!is_active)
    }
    const getWalletDetails=()=>{
        setLoading(true)
        API.get(GET_WALLET_DETAILS+ companyId)
        .then(res=>{
            if(res.status==200){
                setLoading(false)
                setIsActive(res.data.data.credit_enabled)
                setCurrentCredits(res.data.data.total_credits)
                setUserDetails(res.data.data)
                setPerSearchCredit(res.data.data.rate ?? "")
                setSelectedCreditType(res?.data?.data.credit_type)

                const apiSlabs = res?.data?.data?.slabs
                if (Array.isArray(apiSlabs) && apiSlabs.length) {
                    const sorted = [...apiSlabs].sort(
                        (a, b) => (a.slab_order ?? 0) - (b.slab_order ?? 0)
                    )
                    setSlabs(
                        sorted.map(s => ({
                            from_search: s.lower_bound ?? '',
                            to_search: s.upper_bound ?? '',
                            credit_per_search: s.rate ?? '',
                        }))
                    )
                }
            }
        })
        .catch(err=>{
            setLoading(false)
            console.log(err);
            
        })
    }
    const setCredits=(e)=>{
        e.preventDefault()
        if (userDetails.credit_type === "staggered" && selectedCreditType === "flat"
            && !window.confirm("Switching to Flat will delete the configured slabs. Continue?")) return
        let apiData={
            company_id: Number(companyId),
            credit_enabled: is_active,
            credit_type: selectedCreditType,
          }
        if (selectedCreditType === "staggered") {
            const validSlabs = slabs
                .filter(s => s.from_search !== '' && s.to_search !== '' && s.credit_per_search !== '')
                .map((s, index) => ({
                    slab_order:index+1,
                    lower_bound: Number(s.from_search),
                    upper_bound: Number(s.to_search),
                    rate: Number(s.credit_per_search),
                }))

            if (validSlabs.length === 0) {
                cogoToast.error("Please define at least one slabs")
                return
            }

            apiData.slabs = validSlabs
        } else {
            apiData.flat_credit_rate = perSearchCredit
        }
        setLoading(true)
        
        API.post(UPDATE_ISSUER_WALLET,apiData)
        .then(res=>{
            if(res.status==200){
                setLoading(false)
                cogoToast.success(res.data.message)
                getWalletDetails()
            }
        })

        .catch(err=>{
            setLoading(false)
            cogoToast.error(err.response.data.message)

        })
    }

    const handleCredits=(e,action)=>{
        e.preventDefault()
        if(amount==""){
            cogoToast.error("Enter Amount to Credit or Debit")
        }
        else if(description==""){
            cogoToast.error("Enter Description")
        }
        else{
        setLoading(true)

        let apiData={
            company_id: Number(companyId),
            entry_type: action,
            amount: amount,
            reason: description
          }
        API.post(ISSUER_ADJUST_CREDITS, apiData)
        .then(res=>{
            if(res.data.status==200){
                setLoading(false)
                cogoToast.success(res.data.message)
                getWalletDetails()
                setAmount("")
                setDescription("")
            }
        })
        .catch(err=>{
            setLoading(false)
            cogoToast.error(err.response.data.message)
            
        })
        
    }
    }
    useEffect(()=>{
        getWalletDetails()

    },[])
  return (
    
    <SlideUpWrapper direction="slide-left">


        <Loader isOpen={loading}/>
            <div className={[styles.companyProfile, templateStyles.templateHeader].join(" ")}>
                <IssuerNavigator
                    title={`Credit Management ${userDetails.company_name&& `(${userDetails.company_name})`}`}
                    actions={()=>{}} step={'/users'} />
            </div>
        <div className='w-100 bg-gray-100 p-4 flex items-center justify-center row'>
            <div className=" w-50 bg-white rounded-xl shadow-md p-4 border border-gray-200 m-10">
            <div className={creditStyles.headerRow}>
                <div className={`${creditStyles.field} ${creditStyles.creditType}`}>
                <h2>Credit Type</h2>
                {loading?<div className='shimmer'></div>:
                <div className={creditStyles.dropdownWrap}>
                <CustomDropDown
                                list={CreditStatus}
                                selectedOption={selectedCreditType}
                                onSelect={(e) => {setSelectedCreditType(e)}}
                                width="80%"
                              />
                </div>
                }
                </div>
            <div className={`${creditStyles.field} ${creditStyles.walletService}`}>
                <h2>Wallet Service</h2>

                <div className={creditStyles.toggleRow}>
                <div className="checkbox-wrapper-22">
                                  <label
                                    className="switch"
                                    htmlFor={`checkbox`}
                                  >
                                    <input
                                      type="checkbox"
                                      id={`checkbox`}
                                      checked={is_active}
                                      onChange={()=>handleCredit()}
                                    />
                                    <div className="slider round"></div>
                                  </label>
                                </div>

                <div className={`${creditStyles.statusBadge} ${is_active ? creditStyles.statusActive : creditStyles.statusInactive}`}>{is_active?"Activated":"Deactivated"}</div>
                </div>
            </div>
            </div>
      <div className="flex items-center justify-between">
      <div className="text-gray-600 space-y-2">
            <div className='flex items-baseline gap-2' style={{margin:"10px 0px"}}>
                <h2 style={{marginBottom:"15px"}}>Current Balance:</h2>
                {loading?<div className='shimmer'></div>:
                <div className={styles.balance}><span id="balance">{currentCredits}</span></div>}
            </div>
        {selectedCreditType=="flat" && is_active &&
        <>    <div>
                <h2 style={{marginBottom:"7px"}}>Per search credits</h2>
                {loading?<div className='shimmer'></div>:
                <div className={styles.balance}><span id="balance">{userDetails.rate==null?"NA":userDetails.rate}</span></div>}
            </div>



            <div>
                <h2>Set per search credits</h2>
                <div><input type="text" className="border border-gray-300 rounded px-3 py-2 focus:outline-none focus:border-blue-500" value={perSearchCredit} onChange={(e)=>setPerSearchCredit(e.target.value)}/></div>
            </div>
            </>
             }   
            {selectedCreditType=="staggered" && is_active && <div>
                <h2 style={{margin:"10px 0px"}}>Set per search credits by slab</h2>
                <span>Each slab is a range of searches. Credits per search apply to every search that falls inside the range.</span>
            </div>}
      </div>
      </div>

      {selectedCreditType=="staggered" && is_active &&
      <div className="w-100 mt-10">
                <StaggerredCredit slabs={slabs} setSlabs={setSlabs} />
      </div>}

      <div className="w-100 flex items-center justify-center mt-4">
                <button className='btn btn-primary' onClick={(e)=>setCredits(e)}>Submit</button>
      </div>

    </div>


    <div className=" w-50 bg-white rounded-xl shadow-md p-4 border border-gray-200 flex items-center justify-center row m-5"> 
      <div className='w-100 flex align-center justify-center'>
                <h2>Credit/Debit Credits</h2>
      </div>

      <div className='w-50 flex align-center row'>
        <div className='w-100'>
                    <label for="credit-amount" className={styles.balance}>Amount</label>
                    {loading?<div className='shimmer'></div>:
                    <input type="text" value={amount} className='input' id="credit-amount" placeholder="Enter amount to credit/debit" onChange={(e)=>setAmount(e.target.value)}/>}
        </div>
        <div className='w-100 mt-5'>

                    <label for="credit-amount" className={styles.balance}>Description</label>
                    {loading?<div className='shimmer'></div>:
                    <input type="text" value={description} className='input' id="credit-amount" placeholder="Enter Description" onChange={(e)=>setDescription(e.target.value)}/>}
        </div>
      </div>


      <div className='w-100 flex align-center justify-center'>
        <button className={`btn ${styles.accept}`} onClick={(e)=>handleCredits(e, 'credit')}>Credit Amount</button>
        <button className={`btn ${styles.reject}`} onClick={(e)=>handleCredits(e, 'debit')}>Debit Amount</button>
    </div>
    </div>
    </div>

    </SlideUpWrapper>
  )
}

export default CreditHandler